import { useState } from 'react';
import { Button } from '@components/Button';
import {
  Modal,
  ModalContainer,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@components/Modal';
import { BUSINESS_PROFILE_AGREE_WAREHOUSE_TANDCS } from '@constants';
import { useAuthHttp } from '@hooks';
import { useSetAtom } from 'jotai';
import { BusinessProfile } from '@views/Profile/Profile';
import { businessProfileAtom } from '../../store/jotai';

export function AgreeToWarehouseTandCsModal({
  isAgreeToWarehouseTandCsOpen,
  setIsAgreeToWarehouseTandCsOpen,
  handleAfterAgreeingToWarehouseTandCs,
}: {
  isAgreeToWarehouseTandCsOpen: boolean;
  setIsAgreeToWarehouseTandCsOpen: (isOpen: boolean) => void;
  handleAfterAgreeingToWarehouseTandCs?: () => void;
}) {
  const authHttp = useAuthHttp();
  const setBusinessProfile = useSetAtom(businessProfileAtom);
  const [isAgreeing, setIsAgreeing] = useState(false);

  const handleAgreeToWarehouseTandCs = async () => {
    setIsAgreeing(true);
    try {
      const { data } = await authHttp.post<BusinessProfile>(
        BUSINESS_PROFILE_AGREE_WAREHOUSE_TANDCS,
        {}
      );
      if (data.businessProfile.warehouseTandCAgreement.hasAgreed) {
        setIsAgreeing(false);
        setBusinessProfile(data.businessProfile);
        setIsAgreeToWarehouseTandCsOpen(false);
        if (handleAfterAgreeingToWarehouseTandCs) {
          handleAfterAgreeingToWarehouseTandCs();
        }
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    } finally {
      setIsAgreeing(false);
    }
  };
  return (
    <Modal
      open={isAgreeToWarehouseTandCsOpen}
      onOpenChange={(isOpen: boolean) => {
        setIsAgreeToWarehouseTandCsOpen(isOpen);
      }}
    >
      <ModalContainer preventCloseOnOutsideClick>
        <ModalHeader title='Agree to Warehouse Terms and Conditions' />
        <ModalContent>
          <iframe
            src='https://www.flox.is/standard-conditions-of-warehousing-services'
            style={{
              width: '100%',
              height: '100%',
              border: 'none',
              minHeight: '50vh',
            }}
            title='Terms and Conditions'
          />
        </ModalContent>
        <ModalFooter>
          <Button
            variant='primary'
            onClick={handleAgreeToWarehouseTandCs}
            disabled={isAgreeing}
          >
            {isAgreeing ? 'Agreeing...' : 'I agree to the terms and conditions'}
          </Button>
        </ModalFooter>
      </ModalContainer>
    </Modal>
  );
}
